var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33038 19.3221C8.22445 19.3227 8.11943 19.3024 8.02136 19.2623C7.92328 19.2223 7.83408 19.1633 7.75887 19.0887L1.18242 12.5122C0.807611 12.1384 0.51024 11.6942 0.30734 11.2053C0.104441 10.7163 0 10.1921 0 9.6627C0 9.1333 0.104441 8.60911 0.30734 8.12014C0.51024 7.63117 0.807611 7.18704 1.18242 6.81317L7.75887 0.236729C7.83392 0.161677 7.92302 0.102142 8.02108 0.0615239C8.11914 0.0209058 8.22424 7.90805e-10 8.33038 0C8.43652 -7.90805e-10 8.54162 0.0209058 8.63968 0.0615239C8.73774 0.102142 8.82684 0.161677 8.9019 0.236729C8.97695 0.311782 9.03648 0.400882 9.0771 0.498942C9.11772 0.597003 9.13863 0.702104 9.13863 0.808244C9.13863 0.914384 9.11772 1.01948 9.0771 1.11755C9.03648 1.21561 8.97695 1.30471 8.9019 1.37976L2.32545 7.9562C1.87323 8.40899 1.61922 9.02276 1.61922 9.6627C1.61922 10.3026 1.87323 10.9164 2.32545 11.3692L8.9019 17.9456C8.97734 18.0205 9.03723 18.1095 9.07809 18.2076C9.11896 18.3057 9.14 18.4109 9.14 18.5171C9.14 18.6234 9.11896 18.7286 9.07809 18.8267C9.03723 18.9248 8.97734 19.0138 8.9019 19.0887C8.82668 19.1633 8.73748 19.2223 8.63941 19.2623C8.54134 19.3024 8.43632 19.3227 8.33038 19.3221Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIc);
export default __webpack_public_path__ + "static/media/arrow_left_ic.22f5dbd73dfa375971c76915e44ec247.svg";
export { ForwardRef as ReactComponent };